<template>

	<div class="gray-bg" style="min-height: 100vh">

		<div class="middle-box text-center loginscreen animated fadeInDown">
			<div>

				<div>
          <a target="_blank" href="https://www.snatchpark.com/parkbills/">
            <img src="/static/image/parkbills.png">
          </a>
					<img src="/static/image/park_bills_text_black.png">
				</div>

				<h3>Welcome to ParkBills</h3>

        <h3 class="smaller lighter grey" v-show="isLoading"><i class="fa fa-spin fa-spinner"></i></h3>
        <label class="error form-control-feedback" >{{ error }}</label>

        <div v-show="meRoles">
          <h4>Please select account to proceed</h4>

          <div class="wrapper wrapper-content animated fadeInRight">
            <div class="row text-left">
              <div 
                class="col-lg-12 ibox"
                v-for="role in meRoles"
                v-bind:key="role.userID">
                <div class="ibox-content">
                  <a class="row" v-on:click="selectRole(role)">
                    <!--
                    <div class="col-4">
                      <div class="text-center">
                        <img alt="image" class="rounded-circle m-t-xs img-fluid" src="img/a2.jpg">
                        <div class="m-t-xs font-bold">Graphics designer</div>
                      </div>
                    </div>
                    -->
                    <div class="col-8">
                      <h3><strong v-html="getRoleCardTitle(role)"></strong></h3>
                      <div v-html="getRoleCardText1(role)"></div>
                      <div v-html="getRoleCardText2(role)" class="mt-1"></div>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <p class="m-t">
          <small><strong>Copyright</strong> PARKAIDE &copy; 2018</small>
        </p>
				
			</div>
		</div>
    
  </div>

</template>

<script>
import helper from "@/components/Utility/Helper"

export default {
  name: "PageChooseAccount",
  data(){
    return {
      meRoles : null,
      error: null,
      isLoading: false,
    }
  },
  mounted() {
    if(window.location.href.includes('localhost')) {
      document.title = 'Localhost';
    } else if(window.location.href.includes('parkbills.parkaidemobile.com')) {
      document.title = 'ParkBills Dev';
    } else if(window.location.href.includes('devpbills.parkaidemobile.com')) {
      document.title = 'ParkBills Dev';
    }

    try {
      let meRoles = localStorage.getItem('meRoles');
      if(!meRoles) {
        this.isLoading = true;
        this.$http
          .get(
            SERVER_URL + '/api2/me/roles/',
            { headers : { 'x-access-token': user.jwt }}
          )
          .then(response => {
            saveRole(meRoles);
          })
          .catch(error => {
            this.isLoading = false;
            this.error = 'Problem loading account info. ' + context.parseLoginError(error);
            helper.redirect(helper.WEB_URL + '/login', 3000);
          })
      } else {
        this.meRoles = JSON.parse(meRoles);
      }
    } catch(e) {
      this.error = 'Problem loading account info. ' + context.parseLoginError(error);
      helper.redirect(helper.WEB_URL + '/login', 3000);
    }
  },
  methods : {
    async saveRole(meRoles) {
      await helper.saveMeRoles(meRoles);
      this.meRoles = meRoles;
      this.isLoading = false;
    },
    selectRole(role) {
      helper.chooseRole(this, role, false);
    },
    getRoleCardTitle(role) {
      if(role.type) {
        if(role.type === 'Personal') {
          return 'Parker Account';
        } else if(role.type === 'Company') {
          return 'Parker Account';
        } else if(role.type === 'Operator') {
          return 'Operator Account';
        } else if(role.type === 'Parker') {
          return 'Season Account';
        } else if(role.type === 'Superadmin') {
          return 'Operator Account';
        } else if(role.type === 'Internal User') {
          return 'Operator Account';
        }
      }
      return 'Account'
    },
    getRoleCardText1(role) {
      if(role.type) {
        if(role.type === 'Personal') {
          return 'Season Parker';
        } else if(role.type === 'Company') {
          if(role.customerID) {
            return 'Season Parker';
          } else {
            return '';
          }
        } else if(role.type === 'Operator') {
          return role.operatorName;
        }
      }

      return role.operatorName;
    },
    getRoleCardText2(role) {
      if(role.type) {
        if(role.type === 'Personal') {
          return '';
        } else if(role.type === 'Company') {
          if(role.customerID) {
            return '';
          } else {
            return '';
          }
        } else if(role.type === 'Operator') {
          return '<i class="fa fa-star"></i> ' + role.title;
        }
      }

      return '<i class="fa fa-star"></i> ' + role.title;
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Page/User/PageChooseAccount.vue